import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const DasgasDashboardPageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dasgas-dashboard-page" */ '../../pages/dasgas-dashboard'
    ),
);

const HistoricalRecordComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dasgas-dashboard-page" */ '../../pages/dasgas-dashboard/hostorical-record'
    ),
);

const dasgasDashboardRouter = (
  <Route path="dasgas-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="dasgas-dashboard"
            component={<DasgasDashboardPageComponent />}
          />
        </Suspense>
      }
    >
      <Route
        path="historical-record"
        element={
          <ErrorBoundaryContainer
            key="historical-record"
            component={<HistoricalRecordComponent />}
          />
        }
      />
      {accountRouter()}
    </Route>
  </Route>
);

export default dasgasDashboardRouter;
